<template>
  <section>
    <div class="toolbar">
      <div>
        <h1>审核日志</h1>
        <p>一个内容一条记录（多轮审核合并为最新状态），点「详情」可查看发布内容全文、图片与全部审核记录，记录只增不删。</p>
      </div>
      <el-button icon="el-icon-refresh" @click="reload">刷新</el-button>
    </div>

    <div class="filters">
      <el-select v-model="query.type" clearable placeholder="内容类型" style="width:150px" @change="reload">
        <el-option label="全部类型" value="all" />
        <el-option label="闲置商品" value="goods" />
        <el-option label="邻里需求" value="demand" />
        <el-option label="邻里服务" value="service" />
      </el-select>
      <el-select v-model="query.result" clearable placeholder="最新结果" style="width:140px" @change="reload">
        <el-option label="全部结果" value="all" />
        <el-option label="通过" value="approve" />
        <el-option label="驳回" value="reject" />
      </el-select>
      <el-select v-model="query.reviewerId" clearable placeholder="审核人" style="width:180px" @change="reload">
        <el-option v-for="r in reviewerOptions" :key="r.reviewerId" :value="r.reviewerId"
          :label="`${r.reviewerName || '未填写'} ${r.reviewerPhone || ''}（${r.total}）`" />
      </el-select>
      <el-date-picker v-model="range" type="daterange" unlink-panels value-format="yyyy-MM-dd"
        start-placeholder="开始日期" end-placeholder="结束日期" style="width:250px" @change="onRangeChange" />
      <el-input v-model="query.keyword" clearable placeholder="内容标题 / 审核人手机号" style="width:220px"
        @keyup.enter.native="reload" @clear="reload" />
      <el-button type="primary" icon="el-icon-search" @click="reload">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table v-loading="loading" :data="rows" border stripe>
      <el-table-column label="内容" min-width="220">
        <template slot-scope="s">
          <div class="cell-title">{{ s.row.contentTitle || ('#' + s.row.contentId) }}</div>
          <div class="cell-sub">{{ s.row.contentTypeLabel }} · ID {{ s.row.contentId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="审核轮次" width="120" align="center">
        <template slot-scope="s">
          <div>第 {{ s.row.round }} 轮</div>
          <div class="cell-sub">共 {{ s.row.rounds }} 轮</div>
        </template>
      </el-table-column>
      <el-table-column label="最新结果" width="90" align="center">
        <template slot-scope="s">
          <el-tag :type="s.row.result === 'approve' ? 'success' : 'danger'" size="mini">{{ s.row.resultLabel }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="当前状态" width="170">
        <template slot-scope="s">{{ s.row.beforeStatus }} → {{ s.row.afterStatus }}</template>
      </el-table-column>
      <el-table-column label="最新审核人" width="170">
        <template slot-scope="s">
          <div>{{ s.row.reviewerName || '未填写' }}</div>
          <div class="cell-sub">{{ s.row.reviewerPhone || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="最新审核时间" width="165">
        <template slot-scope="s">{{ formatTime(s.row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="80" fixed="right" align="center">
        <template slot-scope="s">
          <el-button type="text" @click="showDetail(s.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination background layout="total, sizes, prev, pager, next" :total="total"
        :page-size="query.pageSize" :current-page="query.page" :page-sizes="[20, 50, 100]"
        @size-change="onSizeChange" @current-change="onPageChange" />
    </div>

    <div v-if="!loading && !rows.length" class="empty">还没有审核日志，审核人员在小程序端完成一次审核后会出现在这里。</div>

    <el-dialog :title="detail ? `${detail.contentTypeLabel}审核详情` : '审核详情'" :visible.sync="detailVisible" width="680px">
      <div v-loading="detailLoading" class="audit-detail">
        <template v-if="detail">
          <div class="block-title">发布内容</div>
          <div v-if="detail.content" class="content-card">
            <div class="c-head">
              <span class="c-title">{{ detail.content.title || '（无标题）' }}</span>
              <el-tag size="mini" :type="statusTagType(detail.content.status)">{{ detail.content.status }}</el-tag>
            </div>
            <div v-if="detail.content.images && detail.content.images.length" class="c-images">
              <el-image v-for="(img, i) in detail.content.images" :key="i" :src="img" fit="cover"
                class="c-img" :preview-src-list="detail.content.images" />
            </div>
            <div class="c-body">{{ detail.content.content || '（无详细描述）' }}</div>
            <div class="c-meta">
              <div v-if="detail.content.price != null" class="c-row">
                <span class="c-k">价格</span><span>{{ detail.content.price ? '¥' + detail.content.price : '免费送' }}</span>
              </div>
              <div v-if="detail.content.reward" class="c-row">
                <span class="c-k">悬赏</span><span>¥{{ detail.content.reward }}</span>
              </div>
              <div v-if="detail.content.address" class="c-row">
                <span class="c-k">位置</span><span>{{ detail.content.address }}</span>
              </div>
              <div class="c-row">
                <span class="c-k">发布人</span>
                <span>{{ detail.content.authorName || '未填写' }}（{{ detail.content.authorPhone || '-' }}，ID {{ detail.content.authorId }}）</span>
              </div>
              <div class="c-row"><span class="c-k">发布时间</span><span>{{ formatTime(detail.content.createdAt) }}</span></div>
            </div>
          </div>
          <div v-else class="content-gone">该内容已被发布者删除，以下审核记录仍然保留可查。</div>

          <div class="block-title">审核记录（{{ detail.logs.length }} 轮）</div>
          <div v-for="log in detail.logs" :key="log.id" class="log-item">
            <div class="log-head">
              <el-tag :type="log.result === 'approve' ? 'success' : 'danger'" size="mini">{{ log.resultLabel }}</el-tag>
              <span class="log-round">第 {{ log.round }} 轮</span>
              <span class="log-time">{{ formatTime(log.createdAt) }}</span>
            </div>
            <div class="log-row">
              <span class="c-k">审核人</span>
              <span>{{ log.reviewerName || '未填写' }}（{{ log.reviewerPhone || '-' }}，ID {{ log.reviewerId }}）</span>
            </div>
            <div class="log-row"><span class="c-k">状态变化</span><span>{{ log.beforeStatus }} → {{ log.afterStatus }}</span></div>
            <div v-if="log.reason" class="log-row"><span class="c-k">驳回原因</span><span class="reason-text">{{ log.reason }}</span></div>
          </div>
          <div v-if="!detail.logs.length" class="content-gone">暂无审核记录。</div>
          <div class="d-tip">审核记录由系统自动写入，不可修改、不可删除，用于追责留档。</div>
        </template>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import request from '@/api/request';
export default {
  data() {
    return {
      rows: [],
      total: 0,
      loading: false,
      reviewerOptions: [],
      range: null,
      detailVisible: false,
      detailLoading: false,
      detail: null,
      query: { type: 'all', result: 'all', reviewerId: '', keyword: '', from: '', to: '', page: 1, pageSize: 20 }
    };
  },
  created() {
    this.loadReviewers();
    this.load();
  },
  methods: {
    formatTime(value) {
      if (!value) return '-';
      const d = new Date(value);
      if (isNaN(d.getTime())) return String(value);
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    statusTagType(status) {
      if (status === '在售' || status === '正常') return 'success';
      if (status === '待审核') return 'warning';
      if (status === '审核不通过') return 'danger';
      return 'info';
    },
    async showDetail(row) {
      this.detailVisible = true;
      this.detailLoading = true;
      this.detail = null;
      try {
        const r = await request.get('/admin/reviewers/logs/detail', { params: { type: row.contentType, id: row.contentId } });
        this.detail = r.data;
      } catch (e) {
        this.detailVisible = false;
        this.$message.error((e.response && e.response.data && e.response.data.message) || '详情加载失败');
      } finally { this.detailLoading = false; }
    },
    async load() {
      this.loading = true;
      try {
        const params = Object.assign({}, this.query);
        Object.keys(params).forEach((k) => {
          if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k];
        });
        const r = await request.get('/admin/reviewers/logs', { params });
        this.rows = r.data.list || [];
        this.total = r.data.total || 0;
        this.query.page = r.data.page || 1;
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.message) || '审核日志加载失败');
      } finally { this.loading = false; }
    },
    async loadReviewers() {
      try {
        const r = await request.get('/admin/reviewers/logs/reviewers');
        this.reviewerOptions = r.data || [];
      } catch (e) { this.reviewerOptions = []; }
    },
    onRangeChange(value) {
      this.query.from = value && value[0] ? value[0] : '';
      this.query.to = value && value[1] ? value[1] : '';
      this.reload();
    },
    onPageChange(page) { this.query.page = page; this.load(); },
    onSizeChange(size) { this.query.pageSize = size; this.query.page = 1; this.load(); },
    reload() { this.query.page = 1; this.load(); },
    reset() {
      this.range = null;
      this.query = { type: 'all', result: 'all', reviewerId: '', keyword: '', from: '', to: '', page: 1, pageSize: 20 };
      this.load();
    }
  }
};
</script>
<style scoped>
.toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.toolbar h1 { margin: 0; color: #24384b; font-size: 22px; }
.toolbar p { margin: 6px 0 0; color: #8493a1; font-size: 13px; }
.filters { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px; }
.cell-title { color: #24384b; }
.cell-sub { margin-top: 2px; color: #98a4b0; font-size: 12px; }
.pager { display: flex; justify-content: flex-end; margin-top: 16px; }
.empty { margin-top: 18px; color: #8493a1; font-size: 13px; text-align: center; }
.block-title { margin: 4px 0 12px; color: #24384b; font-size: 15px; font-weight: 500; }
.content-card { padding: 16px; border: 1px solid #e7edf2; border-radius: 10px; }
.c-head { display: flex; align-items: center; gap: 10px; }
.c-title { color: #24384b; font-size: 15px; font-weight: 500; }
.c-images { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
.c-img { width: 88px; height: 88px; border-radius: 8px; }
.c-body { margin-top: 12px; color: #4a5a68; font-size: 13px; line-height: 1.7; white-space: pre-wrap; }
.c-meta { margin-top: 12px; border-top: 1px solid #f0f3f5; padding-top: 8px; }
.c-row, .log-row { display: flex; gap: 12px; padding: 5px 0; font-size: 13px; color: #3d4b44; }
.c-k { flex: none; width: 64px; color: #98a4b0; }
.content-gone { padding: 14px; border-radius: 8px; background: #f7f9fa; color: #8493a1; font-size: 13px; }
.log-item { margin-top: 10px; padding: 12px 16px; border: 1px solid #e7edf2; border-radius: 10px; }
.log-head { display: flex; align-items: center; gap: 10px; margin-bottom: 6px; }
.log-round { color: #4a5a68; font-size: 13px; }
.log-time { margin-left: auto; color: #98a4b0; font-size: 12px; }
.reason-text { color: #c0563f; }
.d-tip { margin-top: 14px; color: #b3bec8; font-size: 12px; }
</style>
